import React from 'react';
import { useRecoilValue } from 'recoil';
import { blockDisplayHeader, blockSettings, customizedBlock } from 'venn-state';
import { DefaultSubjects } from '../../components/secondary/subjects/default-subjects';
import { Block } from '../../components/core';
import { useTopHoldings } from './logic/useTopHoldings';
import { AsOfDate } from '../../components/secondary/as-of-date';
import { getDateBehavior } from 'venn-utils';

export const TopHoldingsHeader = ({ id }: { id: string }) => {
  const title = useRecoilValue(blockDisplayHeader(id));
  const { subHeader } = useRecoilValue(customizedBlock(id));
  const topHoldingsResult = useTopHoldings(id);
  const blockSetting = useRecoilValue(blockSettings(id));
  const dateBehavior = getDateBehavior(blockSetting.customBlockType);
  const asOfDate = { asOfDate: topHoldingsResult.state === 'READY' ? topHoldingsResult.data.asOfDate : undefined };

  return (
    <>
      <Block.HeaderTopContainer id={id}>
        <Block.Title>
          <Block.Headline id={id}>{title}</Block.Headline>
          {subHeader && <Block.SubHeadline id={id}>{subHeader}</Block.SubHeadline>}
        </Block.Title>

        <Block.Metadata id={id}>
          <AsOfDate holdingsData={asOfDate} dateBehavior={dateBehavior} />
        </Block.Metadata>
      </Block.HeaderTopContainer>

      <DefaultSubjects id={id} relativeToBenchmark={false} />
    </>
  );
};
